export default {
  FileuploadClear: {
    mounted() {
      this.el.addEventListener('click', () => {
        // Immediately remove value on the fileupload field's hidden_input. We do this because
        // latency can cause the server to have empty upload entries for the field, but the form
        // on the client side could still have a value set for the hidden_input that gets submitted
        // if the user clicks to submit too quickly.
        const { hiddenInputId } = this.el.dataset;
        const hiddenInput = document.getElementById(hiddenInputId);

        hiddenInput.removeAttribute('value');

        // Send event to server so that the upload entry is removed.
        this.pushEventTo(this.el, 'clear-uploads');
      });
    },
  },
};
